<template>
  <v-container fluid>
  <v-layout>
    <v-flex xs12>
     <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="6000"
        absolute
        >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-layout row pb-1 mb-1>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-btn rounded small color="secondary"
                class="accent--text logoutbtn" @click="generateInvoice" :disabled="canGenerateInvoice || processingRequest"> Generate Invoice </v-btn>
            <v-progress-linear v-if="showProgressBar" indeterminate></v-progress-linear>
          </v-flex>
      </v-layout>

     <!-- <v-data-table
        v-model="selected"
        :headers="headers"
        :items="invoices"
        show-select
        class="elevation-1"
      > -->
      <v-data-table
       v-model="selected"
  :headers="headers"
  :items="invoices"
  :loading="loadingPage"
  :server-items-length="totalInvoices"
  :options.sync="pagination"


  show-select
  class="elevation-1"
>


      <template v-slot:item.dateBought="{ item }">
         {{item.dateBought | prettyDate }}
      </template>
      </v-data-table>
     <!-- Loading Overlay -->
     <v-overlay :value="loadingPage">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
    </v-flex>
  </v-layout>
  </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'

  export default {
    name: 'buyerinvoices',
    data: function () {
      return {
        headers: [
          { text: 'Payable To', value: 'buyerName' },
          { text: 'Lot Number', value: 'lotNumber' },
          { text: 'Invoice Amount', value: 'totalValue' },
          { text: 'Number Of Bags', value: 'bagsBought' },
          { text: 'Total Weight', value: 'weightBought' },
          { text: 'Price', value: 'price' },
          { text: 'Auction Status', value: 'status' },
          { text: 'Auction Date', value: 'dateBought' }
        ],
        data: [],
        message: '',
        error: '',
        loading: false,
        loadingPage: false,
        // pagination: {
        //   sortBy: 'name'
        // },
         pagination: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
        totalInvoices: 0,
        snackbar: false,
        snackbarColor: '',
        messsage: '',
        editedItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        defaultItem: {
          id: '',
          lotNumber: '',
          saleNumber: '',
          buyerCode: '',
          price: ''
        },
        selected: [],
        rejectInvoice: { marketer: {}, totalValue: '' },
        rejectDialog: false,
        processingRequest: false,
        showProgressBar: false
      }
    },
    mounted () {
      // this.getBuyerInvoices()
    },
    watch: {

        pagination: {
    handler() {
      this.getBuyerInvoices();
    },
    deep: true
  }


      // pagination: {
      //   handler () {

      //     this.getDataFromApi()
      //       .then(data => {
      //         // this.users = data.items
      //         // this.totalUsers = data.total
      //       })
      //   },
      //   deep: true
      // }
    },

    computed: {
      canGenerateInvoice: function () {
        if (this.selected.length === 0 || this.processingRequest) {
          return true // Disable the button if nothing is selected or a request is being processed
        } else {
          return false // Enable the button if there are selected records and no request is being processed
        }
      }
    },
    methods: {
      rejectInvoiceDialog (item) {
        this.rejectDialog = true
        this.rejectInvoice = item
      },
      closeInvoiceDialog () {
        this.rejectInvoice = { marketer: {}, totalValue: '' }
        this.rejectDialog = false
      },
      rejectInvoiceFunction () {
        const url = config.serverURI + '/invoice/reject'
        axios.post(url, this.rejectInvoice)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.invoices = this.getBuyerInvoices()
            this.message = response.data.message
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
        this.closeInvoiceDialog()
      },
      requestEslipDialog (item) {
        this.editedIndex = this.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      save () {
        this.sendRequest()
        this.close()
      },
      sendRequest () {
        const url = config.serverURI + '/invoice/requesteslip'
        axios.post(url, this.editedItem)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.invoices = this.getBuyerInvoices()
            this.message = response.data.message
            this.snackbarColor = 'primary'
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
      },
   getBuyerInvoices() {
  console.log('Fetching invoices with pagination:', this.pagination);
  this.loadingPage = true;

  const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;

  let size = itemsPerPage;
  if (size === -1) {
    size = this.totalData || 1000; // fallback if totalInvoices unknown
  }

  // Convert Vuetify options to backend params
  const params = {
    page: page - 1, // Backend usually starts from 0
    size: size,
    sort: sortBy.length ? `${sortBy[0]},${sortDesc[0] ? 'desc' : 'asc'}` : null
  };

  // Remove null params
  Object.keys(params).forEach(key => params[key] === null && delete params[key]);

  const url = config.serverURI + '/auction/generate';

  axios.get(url, { params })
    .then(response => {
      console.log('Response data:', response.data);
      this.invoices = response.data.content || response.data.items || [];
      this.totalInvoices = response.data.totalElements || response.data.total || 0;
    })
    .catch(error => {
      console.error('error', error);
      this.message = error.response?.status || 'Request failed';
      this.snackbar = true;
      this.snackbarColor = 'error';
    })
    .finally(() => {
      this.loadingPage = false;
    });
},


      toggleSelect (props) {
        // eslint-disable-next-line
        if (props.item.status == 1) {
          props.selected = !props.selected
        }
      },

  //     getBuyerInvoices () {
  //   // Set the loading flag before making the request
  //   this.loadingPage = true;

  //   var url = config.serverURI + '/auction/generate';

  //   axios.get(url)
  //     .then(response => {
  //       // Update the invoices data
  //       this.invoices = response.data;

  //       // Filter the invoices based on the status
  //       this.invoices = this.invoices.filter(invoice => invoice.status === 1);
  //     })
  //     .catch(error => {
  //       // Request failed.
  //       console.log('error', error.response);
  //       this.message = error.response.status;
  //       this.snackbar = true;
  //       this.snackbarColor = 'error';
  //     })
  //     .finally(() => {
  //       // Reset the loading flag after the request is complete
  //       this.loadingPage = false;
  //     });
  // }
  // ,
      toggleAll () {
        if (this.selected.length) {
          this.selected = []
        } else {
          const result = this.data.filter(sel => {
            // eslint-disable-next-line
            return sel.status.id == 1
          })
          this.selected = result.slice()
        }
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      generateInvoice () {
        this.processingRequest = true
        this.showProgressBar = true
        // this.loadingPage = true
        console.log(this.selected)
        this.sendGenerateInvoiceRequest()
      },
      sendGenerateInvoiceRequest () {
        const url = config.serverURI + '/invoice/confirm'
        axios.post(url, this.selected)
          .then(response => {
            this.snackbar = true
            if (response.data.error !== false) {
              this.message = response.data.message
              this.snackbarColor = 'error'
              return
            }
            this.message = response.data.message
            this.snackbarColor = 'primary'
            this.selected = []
            this.getBuyerInvoices()
          })
          .catch(error => {
            var data = error.response.data
            this.message = data.status
            this.snackbarColor = 'error'
            this.snackbar = true
          })
          .finally(() => {
            this.processingRequest = false
            this.showProgressBar = false
            // this.loadingPage = false
          })
      },
      triggerDownload (item) {
        var url = config.serverURI + '/invoice/download/' + item.id
        axios.get(url)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            const itemFileName = item.marketer.organisationName + '_' + item.created
            link.setAttribute('download', itemFileName)
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            this.message = error.response.status
            this.snackbar = true
            this.snackbarColor = 'error'
          })
        return this.data
      }
    }
  }

  </script>
  <style>
  .text {
    font-style: 'Open Sans';
    font-size: 16px;
    color: #000;
  }
  </style>
